import { Component, OnInit } from '@angular/core';
import { CardFormatterService } from 'src/app/core/services/card-formatter.service';

@Component({
  selector: 'app-credit-card-selector',
  templateUrl: './credit-card-selector.component.html',
  styleUrls: ['./credit-card-selector.component.scss']
})
export class CreditCardSelectorComponent implements OnInit {

	constructor(
		public cardFormatterService: CardFormatterService
	) { }

	ngOnInit() {
	}
}
